var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "leo-flex leo-flex-col desktop:leo-h-full leo-m-0 leo-m-auto leo-py-xl desktop:leo-py-xs tablet:leo-h-full tablet:leo-py-xs",
      staticStyle: { height: "90vh" },
    },
    [
      _c("overlay", {
        attrs: {
          isLoading: _vm.isLoading,
          displayWhiteBackground: _vm.displayWhiteBackground,
        },
      }),
      [
        _vm.isRedirecting
          ? _c(
              "div",
              {
                staticClass:
                  "leo-fixed leo-top-0 leo-left-0 leo-right-0 leo-bottom-0 leo-w-full leo-h-screen leo-z-5 leo-overflow-hidden leo-bg-grey-600 leo-opacity-75 leo-flex leo-flex-col leo-items-center leo-justify-center",
              },
              [_c("leo-loader")],
              1
            )
          : _vm._e(),
      ],
      _c(
        "div",
        {
          staticClass:
            "leo-flex leo-flex-col leo-gap-xl desktop:leo-gap-md leo-flex-grow",
        },
        [
          _vm._t("progress-stepper"),
          _c(
            "div",
            {
              staticClass: "leo-text-lg leo-text-secondary leo-font-semibold",
              class: _vm.headingClass,
            },
            [_vm._v(" " + _vm._s(_vm.heading) + " ")]
          ),
          _vm._t("confirmation-text"),
          _vm.imageType
            ? _c(
                "div",
                { staticClass: "leo-justify-items-center" },
                [
                  _vm.imageType === "homepage"
                    ? _c("home-page")
                    : _vm.imageType === "protection"
                    ? _c("protection")
                    : _vm.imageType === "sign-out"
                    ? _c("signout")
                    : _vm.imageType === "missing-info"
                    ? _c("missing-info")
                    : _vm.imageType === "successful-fund-switch"
                    ? _c("successful-fund-switch")
                    : _vm.imageType === "member-id"
                    ? _c("member-id")
                    : _vm.imageType === "policy-no-fund"
                    ? _c("policy-no-fund")
                    : _vm.imageType === "update-myinfo"
                    ? _c("update-myinfo")
                    : _c("leo-illustration", {
                        attrs: { imageType: _vm.imageType, width: "100%" },
                      }),
                ],
                1
              )
            : _vm._e(),
          !_vm.isSubHeadingHtml && _vm.subheading
            ? _c(
                "div",
                { staticClass: "leo-text-md leo-text-accent break-word" },
                [_vm._v(" " + _vm._s(_vm.subheading) + " ")]
              )
            : _vm.isSubHeadingHtml && _vm.subheading
            ? _c("div", {
                staticClass: "leo-text-md leo-text-accent break-word",
                domProps: {
                  innerHTML: _vm._s(_vm.sanitizedHtml(_vm.subheading)),
                },
              })
            : _vm._e(),
          _vm._t("default"),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }